// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"ee7b1629","787":"705de0a7","863":"ed491955","935":"760aa5fe"}[chunkId] + ".chunk.js";
};